import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getImageUrl } from '../../../../utils/imageUrl';
import './ApproveReturnModal.css';

interface ApproveReturnModalProps {
  show: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  isLoading?: boolean;
  context?: 'return' | 'cancellation'; // Context for modal text
}

const ApproveReturnModal: React.FC<ApproveReturnModalProps> = ({
  show,
  handleClose,
  handleConfirm,
  isLoading = false,
  context = 'return'
}) => {
  const handleModalClose = () => {
    if (!isLoading) {
      handleClose();
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={handleModalClose}
      id="approveReturnModal" 
      className="approve-return-modal fade zoomIn" 
      dialogClassName="modal-dialog-centered"
      centered
      backdrop={isLoading ? 'static' : true}
      keyboard={!isLoading}
    >
      <Modal.Body className="approve-return-modal-body">
        <div className="approve-return-content">
          {/* Illustration Image */}
          <div className="approve-return-image-container">
            <img 
              src={getImageUrl('admin/static-assets/shop-services/Success.webp')} 
              alt="Approve Return" 
              className="approve-return-image"
            />
          </div>
          
          {/* Heading */}
          <h4 className="approve-return-title">
            {context === 'cancellation' ? 'Approve Cancellation?' : 'Approve Return?'}
          </h4>
          
          {/* Message */}
          <p className="approve-return-message">
            Are you sure you want to approve<br />
            this {context === 'cancellation' ? 'cancellation' : 'return'} request?
          </p>
          
          {/* Buttons */}
          <div className="approve-return-button-container">
            <Button 
              type="button" 
              variant="outline-secondary" 
              className="approve-return-button approve-return-cancel-button" 
              onClick={handleModalClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button 
              type="button" 
              variant="primary" 
              className="approve-return-button approve-return-confirm-button" 
              onClick={handleConfirm}
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : 'Approve'}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ApproveReturnModal;
